import { Outlet } from 'react-router-dom';
import { ForbiddenPage } from '../../app/pages';
import { usePermissions } from './useAuth';

/** Route-level gate mirroring the API's `@RequirePermission`. The server is
 * still the authority; this just keeps the UI from routing somewhere the
 * caller would only get a 403 anyway. */
export function RequirePermission({ anyOf }: { anyOf: string[] }) {
  const permissions = usePermissions();
  if (!permissions.canAny(anyOf)) return <ForbiddenPage />;
  return <Outlet />;
}
